export const CardSkeleton = () => (
  <div className='flex flex-col gap-4 py-5 px-4 sm:p-6 border border-extra-soft rounded-md bg-surface-primary'>
    <div className='flex flex-row w-full gap-2 sm:gap-4'>
      <div className='h-5 w-5 bg-tertiary rounded-full shrink-0' />
      <div className='flex-1 space-y-2'>
        <div className='h-5 bg-tertiary rounded-sm w-3/4' />
        <div className='h-4 bg-tertiary rounded-sm w-1/2 opacity-70' />
      </div>
      <div className='flex flex-col items-end gap-2 shrink-0'>
        <div className='h-4 w-4 bg-tertiary rounded-sm' />
        <div className='h-5 w-16 bg-tertiary rounded-sm' />
      </div>
    </div>
  </div>
);
